export interface EstimateCostOfChimneyWork {
  ChimneyWorkCost: number;
}

export interface ChimneyWorkItem {
  Item: string;
  check: boolean;
  Type: string;
}

export interface GetAllFee {
  'Certification Cost': number;
  totalFee: number;
  summary: any[];
}

export interface ChimneyData {
  EstimateCostOfWork: EstimateCostOfChimneyWork;
  WorkItems: ChimneyWorkItem[];
  getAllFee: GetAllFee;
}

export const chimneyData: ChimneyData = {
  EstimateCostOfWork: {
    ChimneyWorkCost: 0,
  },
  WorkItems: [
    {
      Item: '"B" Label Vent',
      check: false,
      Type: 'Chimney'
    },
    {
      Item: 'Flexible Liner',
      check: false,
      Type: 'other'
    },
    {
      Item: '"L" Label Vent',
      check: false,
      Type: 'other'
    },
    {
      Item: 'Masonry Chimney-Tile Lined',
      check: false,
      Type: 'other'
    },
    {
      Item: 'Power Vent Exhauster',
      check: false,
      Type: 'other'
    },

    {
      Item: 'Masonry Chimney-Unlined',
      check: false,
      Type: 'other'
    },
    {
      Item: 'Chimney-Interior',
      check: false,
      Type: 'other'
    },
    {
      Item: 'Chimney-Exterior',
      check: false,
      Type: 'other'
    }
  ],
  getAllFee: {
    'Certification Cost': 0,
    totalFee: 0,
    summary: [],
  },
};
